// Desktop product grid: 4 columns by default, with 3- and 2-column options.
theme.collectionProduct = (function () {
  function productGrid() {
    var grid = document.getElementById("ProductGridContainer");
    var buttons = document.querySelectorAll(
      ".product__grid_column_buttons .gird__column_icon"
    );

    if (!grid || !buttons.length) return;

    function updateImages(columns) {
      var attribute = "data-sizes-" + columns;
      var images = grid.querySelectorAll("img[data-sizes-2]");

      for (var index = 0; index < images.length; index += 1) {
        var sizes = images[index].getAttribute(attribute);
        if (sizes) images[index].setAttribute("sizes", sizes);
      }
    }

    function setColumns(columns) {
      var className = "grid-col-" + columns;

      grid.classList.remove(
        "grid-col-1",
        "grid-col-2",
        "grid-col-3",
        "grid-col-4",
        "grid-col-5"
      );
      grid.classList.add(className);
      grid.setAttribute("data-grid-columns", columns);

      for (var index = 0; index < buttons.length; index += 1) {
        var button = buttons[index];
        var active = button.classList.contains("product_col_" + columns);
        button.classList.toggle("active", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      }

      updateImages(columns);
    }

    for (var index = 0; index < buttons.length; index += 1) {
      if (buttons[index].getAttribute("data-grid-switcher-bound") === "true") {
        continue;
      }

      buttons[index].setAttribute("data-grid-switcher-bound", "true");
      buttons[index].addEventListener("click", function () {
        if (this.classList.contains("product_col_two")) setColumns(2);
        if (this.classList.contains("product_col_three")) setColumns(3);
        if (this.classList.contains("product_col_four")) setColumns(4);
      });
    }

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        updateImages(grid.getAttribute("data-grid-columns") || "4");
      });
      observer.observe(grid, { childList: true, subtree: true });
    }

    setColumns(4);
  }

  return productGrid;
})();
